import React, {useState, useEffect} from 'react';
import { styled } from "@mui/material/styles";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import ColorModification from './ColorModification';
import { resetLayers } from '../../../reducers/configurator/utils';
import { updateElement, updateModalManager } from '../../../reducers/configurator/configuratorSlice';
import { useDispatch } from 'react-redux';

const PREFIX = 'eventModification'

const classes = {
  colorPicker: `${PREFIX}-colorPicker`,
  confirmButton: `${PREFIX}-confirmButton`
}

const EventModificationContainer = styled('div')((
  {
    theme
  }
) => {
  return {
    [`& .${classes.colorPicker}`]: {
      margin: '1rem 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    [`& .${classes.confirmButton}`]: {
      position: 'relative',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  }
})

const EventModification = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [state, setState] = useState(null)
  const selectedTile = useSelector(state => state.configurator.selectedTile);

  useEffect(() => {
    if (props.element)
      setState(props.element);
  }, [props.element])

  const handleConfirm = () => {
    dispatch(updateElement({
      layer: 'event',
      data: state,
      tile: selectedTile,
    }))
    dispatch(updateModalManager(resetLayers.modalManager));
  }

  return (
    <EventModificationContainer>
      <ColorModification
        element={state}
        handleChange={setState}
      />
      <Button
        variant="contained"
        color="primary"
        component="span"
        className={classes.confirmButton}
        onClick={handleConfirm}
      >
        {t('configurator.confirm')}
      </Button>
    </EventModificationContainer>
  )
}

export default EventModification;